import Http from './base-http'

class MyTask extends Http {
  updateMyTask(id,data) {
    return this.client.put(`TaskAssignment/${id}`,data)
  }

}

const MyTasks = new MyTask({
  modelUrlPrefix : ''
})

export default MyTasks
